<template>
    <div class="classify">
        <classify-list :itemArr="itemList" :panelArr="panelList" >
            <template v-slot="{data}">
                <div class="classifyTitle">{{data.title}}</div>
                <div class="classifyBody">
                    <div class="itemClassify" v-for="(v, index) in data.list" :key="index">
                        <img :src="v.imgUrl" class="imgGoods" />
                        <div class="goodsName">{{v.name}}</div>
                    </div>
                </div>
            </template>
        </classify-list>
    </div>
</template>

<script>
    import ClassifyList from '../../../components/classifyList'
    export default {
        name: "classify",
        components:{
            ClassifyList
        },
        data(){
            return {
                itemList:[
                    {
                        name:'美妆'
                    },
                    {
                        name:'服装'
                    },
                    {
                        name:'家居生活'
                    },
                    {
                        name:'鞋靴'
                    },
                    {
                        name:'箱包世界'
                    },
                    {
                        name:'配饰'
                    },
                    {
                        name:'母婴'
                    },
                    {
                        name:'数码'
                    },
                    {
                        name:'娱乐服务'
                    },
                    {
                        name:'汽车'
                    },
                    {
                        name:'科技'
                    },
                    {
                        name:'新闻'
                    },
                    {
                        name:'休息'
                    },
                    {
                        name:'吃饭'
                    },
                    {
                        name:'睡觉'
                    },
                ],
                panelList:[
                    {
                        title:'美妆',
                        list:[
                            {name:"美妆1",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆2",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆3",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆4",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆5",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆6",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆7",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆8",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆9",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆10",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'},
                            {name:"美妆11",imgUrl:'/manager/fileserver/file/download?id=7f32041b2d4641039657684ce22e9b63'}
                        ]
                    },
                    {
                        title:'服装',
                        list:[
                            {name:"服装1",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装2",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装3",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装4",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装5",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装6",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装7",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装8",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装9",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'},
                            {name:"服装10",imgUrl:'/manager/fileserver/file/download?id=8cef53a60d204bf7b9ac60ec3354d9d3'}
                        ]
                    },
                    {
                        title:'家居生活',
                        list:[
                            {name:"家居生活1",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活2",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活3",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活4",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活5",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活6",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活7",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"家居生活8",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'}
                        ]
                    },
                    {
                        title:'鞋靴',
                        list:[
                            {name:"鞋靴1",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"鞋靴2",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"鞋靴3",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"鞋靴4",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"鞋靴5",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"鞋靴6",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'}
                        ]
                    },
                    {
                        title:'箱包世界',
                        list:[
                            {name:"箱包世界1",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界2",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界3",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界4",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界5",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界6",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"箱包世界7",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'}
                        ]
                    },
                    {
                        title:'配饰',
                        list:[
                            {name:"配饰1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"配饰2",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"配饰3",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"配饰4",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"配饰5",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"配饰6",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                    {
                        title:'母婴',
                        list:[
                            {name:"母婴1",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴2",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴3",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴4",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴5",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴6",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴7",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴8",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'},
                            {name:"母婴9",imgUrl:'/manager/fileserver/file/download?id=f489eee9511442a1859484b3d44bc2ff'}
                        ]
                    },
                    {
                        title:'数码',
                        list:[
                            {name:"数码1",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"数码2",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"数码3",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"数码4",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"数码5",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                            {name:"数码6",imgUrl:'/manager/fileserver/file/download?id=4c1080155ea4485287f67063db00dda3'},
                        ]
                    },
                    {
                        title:'娱乐服务',
                        list:[
                            {name:"娱乐服务1",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务2",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务3",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务4",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务5",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务6",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务7",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务8",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务9",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                            {name:"娱乐服务10",imgUrl:'/manager/fileserver/file/download?id=484ceff81a12479285cabbb4fefe641c'},
                        ]
                    },
                    {
                        title:'汽车',
                        list:[
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"汽车1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},


                        ]
                    },
                    {
                        title:'科技',
                        list:[
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"科技1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                    {
                        title:'新闻',
                        list:[
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"新闻1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                    {
                        title:'休息',
                        list:[
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"休息1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                    {
                        title:'吃饭',
                        list:[
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"吃饭1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                    {
                        title:'睡觉',
                        list:[
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                            {name:"睡觉1",imgUrl:'/manager/fileserver/file/download?id=6990e25c30784b12b0a72d2f209fcf53'},
                        ]
                    },
                ]
            }

        }
    }
</script>

<style scoped lang="scss">
.classify{
    width: 100%;
    height: 100%;
}
    .classifyTitle{
        height: 42px;
        background-color: #f2f2f2;
        line-height: 42px;
        text-indent: 14px;
        letter-spacing: 1px;
        font-size: 14px;
        color: #000;
        font-weight: bold;
        position: relative;
        &:after{
            position: absolute;
            content: '';
            display: block;
            width: 4px;
            height: 60%;
            background-color: red;
            left: 0;
            top: 20%;
        }
    }
    .classifyBody{
        width: 96%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .imgGoods{
        margin: 10px;
        width: 88%;
    }
    .goodsName{
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
    }
    .itemClassify{
        width: 33.33%;
        min-height: 100px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 5px;
    }


</style>
